import { useOktaAuth } from '@okta/okta-react';
import { useQuery } from '@tanstack/react-query';
import { apiGet } from '@/lib/api';
import { QUERY_KEYS } from '@/lib/query-utils';

interface Organization {
  id: string;
  role: string;
  organizationName: string;
}

export interface UserResponse {
  sub: string;
  name: string | null;
  email: string | null;
  picture?: string | null;
  organizationUser?: {
    id: string;
    givenName: string;
    lastName: string;
    preferredName: string;
    email: string;
    organizations: Organization[];
  };
}

export function useUser() {
  const { authState } = useOktaAuth();

  return useQuery({
    queryKey: QUERY_KEYS.User,
    queryFn: () => apiGet<UserResponse>('/api/user'),
    enabled: !!authState?.isAuthenticated,
  });
}
